module.exports = __webpack_public_path__ + "static/header-logo-orange-white-xd.8d1a65da.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/header-logo-orange-white-xd.png
// module id = 1008
// module chunks = 2